import React, {useContext, useState} from 'react';
import {Context} from '../../context';
import LabelAndInput from '../UI/LabelAndInput';
import Button from '../UI/Button';

function EnterCredentials(props) {
  const {localeText, token, transitionAccountLookup} = useContext(Context);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [errors, setErrors] = useState([]);

  const lookupAccount = async e => {
    e.preventDefault();
    const data = {};
    if (email) data.email = email;
    if (cardNumber) data.cardNumber = cardNumber;
    if (username) data.username = username;

    const res = await transitionAccountLookup(data);

    props.handleErrors(res, setErrors);

    if (!res?.data?.lookupAccount) {
      return;
    }

    if (res?.data?.lookupAccount?.status === 'granted') {
      props.setSecurityQuestionPassed(true);
    }
    props.setAccessRequestId(res.data.lookupAccount.accessRequestId.toString());
  };

  return (
    <form className='w-96 gap-1 flex flex-col' onSubmit={lookupAccount}>
      <LabelAndInput
        inputId='migration-username'
        name='username'
        label={localeText('rw_title_username', 'Username')}
        description={localeText(
          'rw_title_migration_username_description',
          '(associated with your account from the previous system)'
        )}
        type='text'
        placeholder={localeText('rw_title_username_placeholder', 'Username')}
        value={username}
        onChange={e => setUsername(e.target.value)}
      />
      <LabelAndInput
        inputId='migration-email'
        name='email'
        label={localeText('rw_title_email', 'email')}
        description={localeText(
          'rw_title_migration_email_description',
          '(associated with your account from the previous system)'
        )}
        type='email'
        placeholder={localeText('rw_title_email_placeholder', 'Email')}
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
      <LabelAndInput
        inputId='migration-card-number'
        name='card-number'
        label={localeText('rw_title_card_number', 'Card Number')}
        description={localeText(
          'rw_title_migration_card_num_description',
          '(any card associated with your account from the previous system)'
        )}
        type='text'
        placeholder={localeText(
          'rw_title_card_number_placeholder',
          'Card Number'
        )}
        value={cardNumber}
        onChange={e => setCardNumber(e.target.value.toString())}
      />
      {errors.length > 0 &&
        errors.map((error, index) => (
          <div key={index} className='text-red text-xl my-4'>
            {localeText(error.slug, error.default)}
          </div>
        ))}
      <Button
        disabled={!token}
        buttonId='migration-continue'
        className='mt-4'
        type='submit'
      >
        {localeText('rw_button_continue', 'Continue')}
      </Button>
    </form>
  );
}

export default EnterCredentials;
